// extracted by mini-css-extract-plugin
export default {"main":"Main_main__F2ek1","mainContent":"Main_mainContent__K3de6","left":"Main_left__XUHTw"};